/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { availabilitySchemeSummarySchema } from './availabilitySchemeSummarySchema';
import { locationSummarySchema } from './locationSummarySchema';
import { skillSummarySchema } from './skillSummarySchema';
import { teamSchema } from './teamSchema';

export const resourceDetailResponseSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  employmentType: z.enum(['EMPLOYEE', 'CONTRACTOR', 'PARTNER', 'ON_DEMAND', 'AI_AGENT']),
  get holidayScheme() {
    return availabilitySchemeSummarySchema;
  },
  id: z.int(),
  isAnonymized: z.boolean(),
  get location() {
    return z.union([locationSummarySchema, z.null()]).optional();
  },
  locationOverridden: z.boolean(),
  loopIds: z.array(z.int()),
  name: z.string(),
  organizationId: z.string(),
  get skills() {
    return z.array(skillSummarySchema);
  },
  sourceId: z.string().nullish(),
  status: z.enum(['ACTIVE', 'DEACTIVATED']),
  syncedMembershipTeamIds: z
    .array(z.int())
    .describe(
      "Teams where this resource's membership is owned by an external system and cannot be edited in Loop",
    ),
  get teams() {
    return z.array(teamSchema);
  },
  type: z.enum(['RESOURCE', 'PLACEHOLDER']),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
  get workloadScheme() {
    return availabilitySchemeSummarySchema;
  },
});
